import React from 'react'
import { Box, FormControl, Alert } from '@mui/material'
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector'
import SelectList from '../../../../../Components/Elements/SelectList'
import { BlockSettingsProps } from './types'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

export const SumFieldsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    if (!state.item.defDossier)
        return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>
    return (
        <Box sx={{ mt: 2 }}>
            <FormControl fullWidth margin="normal">
                <FormInputLabel>{kedo.t('Sum field')}</FormInputLabel>
                <SelectList
                    currentValue={state.item.settings.sum_field}
                    onClear={() => handleChangeSettings('sum_field', null)}
                    searchName="search"
                    kedo={kedo}
                    urlParams={{
                        type: 'amount',
                        environment: kedo.env().getEnvironment().id,
                        defDossier: state.item.defDossier,
                    }}
                    onDisplayName={(item: any) => item.name}
                    url={kedo.api().getDefDossierDefFieldEndpoint()}
                    onSelect={(item: any) =>
                        handleChangeSettings('sum_field', item.id)
                    }
                />
            </FormControl>
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) =>
                    handleChangeSettings('scheme', e.target.value)
                }
                name={'scheme'}
                sx={{ mt: 2 }}
            />
        </Box>
    )
}
